import type { App } from 'vue';
import clickoutside from '@/components/activix-ui/directives/clickoutside.ts';
import tooltip from '@/components/activix-ui/directives/tooltip.ts';

const Directives = {
    install(app: App) {
        app.directive('clickoutside', clickoutside());
        app.directive('tooltip', tooltip());
    },
};

export default Directives;
